import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { FlatpickrModule } from 'angularx-flatpickr';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    declarations: [],
    imports: [CommonModule, FlatpickrModule.forRoot(), NgxMaskModule.forRoot()],
    exports: [FlatpickrModule, NgxMaskModule]
})
export class ResourcesModule {}
